'use client';

import { useState } from 'react';

import { Content } from '@prismicio/client';
import type { Simplify } from '../../../../prismicio-types';
import { Tabs } from '@/components';
import { useVisible } from '@/hooks';

import styles from './statisticsInner.module.scss';
import { StatisticsDescriptions, StatisticsValues } from '.';

interface StatisticsInnerProps {
  data: Simplify<Content.StatisticsSliceDefaultPrimary>;
}

export const StatisticsInner = ({ data }: StatisticsInnerProps) => {
  const [activeItem, setActiveItem] = useState<number>(0);
  const [isVisible, id] = useVisible();

  return (
    <article
      id={id}
      className={`${styles.article} ${isVisible ? styles.isVisible : ''}`}
    >
      <div className={styles.tabs_wrapper}>
        <div className={`${styles.before} ${styles.left}`} />
        <div className={styles.tabs_container}>
          <Tabs
            activeItem={activeItem}
            onClick={setActiveItem}
            tabs={data.items.map((item) => item.tab_text)}
            styles={styles.tabs}
            isVisible={isVisible}
            scrollDirection="right"
          />
        </div>
        <div className={`${styles.before} ${styles.right}`} />
      </div>
      <div className={styles.content}>
        <StatisticsValues
          values={data.items.map((item) => item.value)}
          activeItem={activeItem}
        />
        <StatisticsDescriptions
          items={data.items.map((item) => item.description)}
          activeItem={activeItem}
        />
      </div>
    </article>
  );
};
